/* eslint-disable */
import { CmsPage, CmsAdminPage, CmsAdminApp } from "@invisible-cms/react";
import React from "react";
import { getPlugin } from "./wrap-page";
export const wrapRootElement = ({ element }, options) => {
    if (!process.env.REACT_APP_CMS_NOADMIN) {
        const AuthProvider = getPlugin(require(INVISIBLE_CMS_AUTH_PROVIDER_PATH), INVISIBLE_CMS_AUTH_PROVIDER_PATH);
        const authProvider = new AuthProvider(options);
        return (React.createElement(CmsAdminApp, { authProvider: authProvider, endpoint: options.endpoint }, element));
    }
    else {
        return element;
    }
};
export const wrapPageElement = ({ element, props }) => {
    const { content, pageId, resourceData, resourceUrl } = props.pageContext;
    if (!process.env.REACT_APP_CMS_NOADMIN) {
        return (React.createElement(CmsAdminPage, { rootResourceUrl: resourceUrl, pageId: pageId, resourceData: resourceData }, element));
    }
    else {
        return (React.createElement(CmsPage, { rootResourceUrl: resourceUrl, data: content, resourceData: resourceData }, element));
    }
};
//# sourceMappingURL=gatsby-browser.js.map